/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
class s{constructor(s){this.notify=s,this._accessed=new Set,this._handles=[]}destroy(){this._accessed.clear(),this.clear()}onObservableAccessed(s){this._accessed.add(s)}onTrackingEnd(){for(const s of this._accessed)this._handles.push(s.observe(this));this._accessed.clear()}clear(){for(const s of this._handles)s.remove();this._handles.length=0}}export{s as SimpleTrackingTarget};
